
// @ts-nocheck





import { i18nText } from '@/locales';


import { ISalonsListItem } from '@/entity/salons/salons.types';
import { SalonsStore } from '@/store/modules/Salons';
import { SettingsUsersStore } from '@/store/modules/Settings/User'
import PageTitle from '@/UI/components/common/PageTitle.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import AppSimpleLink from '@/UI/components/Link/AppSimpleLink.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Button, Menu, List, Table, Select, FormModel } from 'ant-design-vue';
import { UsersSettingsMix } from '@/UI/mixins/Store/UsersSettingsMix';
import { UsersSettingsTableMix } from '@/UI/mixins/Store/UsersSettingsTableMix';
import { SalonsMix } from '@/UI/mixins/SalonsMix';
import { UserFormData, FormRules } from '@/form/Settings/userSettings';
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { getStudioId } from '@/UI/lib/state';
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import { FiltersData } from "@/entity/filters/extFilter";
import AppFilterTable from "@/UI/components/extFilter/AppFilterTable.vue";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"
import RolesRepository from "@/repository/user/roles/RolesRepository";
import { ProxyGetData } from "@/UI/components/Helpers/getData";
import { appPaginationStore } from "@/store/modules/appPagination";
import { AuthStore } from '@/store/modules/Auth'

@Component({
  components: {
    'a-button': Button,
    'a-menu-item': Menu.Item,
    'a-list-item': List.Item,
    'a-list-item-meta': List.Item.Meta,
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-table': Table,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,

    PageTitle,
    BaseDataForm,
    AppSimpleLink,
    AppFilterTable,
    SortComponent,
    FilterTableComponent
  },
})
export default class UsersSettings extends mixins(
  UsersSettingsMix,
  UsersSettingsTableMix,
  ProxyGetData,
  SalonsMix
) {
  filtersData = new FiltersData();
  showModal = false;
  modalTitle = '';
  modalMode = 0;
  userEditMode = 0;
  searchTimeOut: any;
  value = '';
  form = new UserFormData();
  dataSearch: Array<ISalonsListItem> = [];
  mode_select = 'multiple'
  rules = FormRules;
  mask_phone = ""
  pickedStudioName = i18nText("Не указано")
  isFormValid = false;
  isLoading = false;
  filter_load = false;
  currentlySelectedStudio = this.$route.params.Studio;

  filtersData = new FiltersData();
  validation: Record<string, any> = {}

  /*async beforeRouteUpdate(to, from, next): Promise<void> {
    this.currentlySelectedStudio = to.params.Studio;
    await this.getUsersData();
  }*/

  @Watch("form.role_id", { immediate: true })
  onRouteChange(value): void {
    if (value === 0) {
      this.form.role_id = null;
    }
  }

  get userData(): any {
    return AuthStore.userData
  }
  async filterCallback(filterData: Array<Record<any, any>>): Promise<void> {
    await this.fetchSettingsStore(this.filtersData.filtered_values);
  }

  addUser(): void {
    console.log('add user')
    this.resetValidationFields();
    this.form = new UserFormData();
    this.mask_phone = "+# (###) ###-####"
    this.modalTitle = i18nText("Добавить пользователя");
    this.userEditMode = 0;
    this.resetValidationFields();
    this.showModal = true;
  }

  handleCancel(): void {
    this.showModal = false;
    this.resetValidationFields();
  }

  selectRoleMode() {
    this.validation.role.help = '';
    this.mode_select = 'multiple';
  }

  async editUser(record: any) {
    if (!record.roles?.length || (record.id !== this.userData.id && !this.roles.some(role => role.id === record.roles[0].id))) return;
    this.mask_phone = "+# (###) ###-####";
    this.form.setFormData(record);
    this.form.studios = record.studios.map(studio => studio.id);
    this.form.role_id = record.roles[0].id;
    this.form.password = '';
    this.modalTitle = i18nText("Редактировать");
    this.resetValidationFields();
    this.showModal = true;
    this.userEditMode = 1;
  }

  async onDelete() {
    await SettingsUsersStore.delete({ id: this.form.id })
    this.showModal = false
    await this.fetchSettingsStore()
  }

  resetValidationFields(): void {
    this.isFormValid = false;
    this.validation = {
      name: {
        status: 'success',
        help: ''
      },
      email: {
        status: 'success',
        help: ''
      },
      phone: {
        status: 'success',
        help: ''
      },
      role: {
        status: 'success',
        help: ''
      },
      studios: {
        status: 'success',
        help: ''
      },
      password: {
        status: 'success',
        help: ''
      },
    };
    for (const field in this.validation) {
      this.validation[field].status = '';
      this.validation[field].help = '';
    }
    console.log('add user', this.validation)
  }


  setFilters(that: any): void {
    this.filtersData.filters = [];
    let rolesStudioArr = this.roles.map((element, i) => {
      return { label: element.name, key: element.id, id: element.id }
    })
    this.filtersData.filters.push(
      {
        key: 1,
        type: 'input',
        label: i18nText("Имя"),
        default_value: '',
        placeholder: i18nText("Имя"),
        filtered: false,
        fieldNames: ['target_value'],
        async onChange(e: any) {
          let filter = {};
          filter.name = e.target.value;
          await that.filterData(filter)
        },
      },
      {
        key: 2,
        type: "select",
        label: i18nText("Роль"),
        default_value: [i18nText("Не указано")],
        value: rolesStudioArr,
        async onChange(value: any) {
          let filter = {};
          filter.role_id = value;
          await that.filterData(filter)

        },
        async onScroll() {
        },
        async onFocus() {
        },
        async onSearch() {
        }
      },
    )
    this.filter_load = true
  }

  // setFilters(that: any): void {
  //   let thisRef = this;

  //   /*let filterStudioArr =  this.salons.data.map((element, i) => {
  //     return {label: element.name, key: i}
  //   })*/

  //   this.filtersData.filtered_values = {};

  //   let rolesStudioArr =  this.roles.map((element, i) => {
  //     return {label: element.name, key: element.id, id: element.id}
  //   })
  //   this.filtersData.filters.push(
  //       // {
  //       //   key: 0,
  //       //   type: "select",
  //       //   label: "Студия",
  //       //   default_value: ['Не указано'],
  //       //   value: filterStudioArr,
  //       //   async onChange(value: any) {
  //       //     await that.filterData({
  //       //       sex: value
  //       //     })
  //       //   },
  //       //   async onScroll() {
  //       //   },
  //       //   async onFocus() {
  //       //   },
  //       //   async onSearch() {
  //       //   }
  //       // },
  //       {
  //           key: 1,
  //           type: 'input',
  //           label: 'Имя',
  //           default_value: '',
  //           placeholder: 'Имя',
  //           filtered: false,
  //           fieldNames: ['target_value'],
  //           async onChange(e: any) {
  //             if(e.target.value) {
  //               thisRef.filtersData.filtered_values.name = e.target.value.toString();
  //             } else if(thisRef.filtersData.filtered_values.name) {
  //               delete thisRef.filtersData.filtered_values.name;
  //             }
  //             await thisRef.fetchSettingsStore(thisRef.filtersData.filtered_values);
  //           },
  //       },
  //       {
  //         key: 2,
  //         type: "select",
  //         label: "Роль",
  //         default_value: ['Не указано'],
  //         value: rolesStudioArr,
  //         async onChange(value: any) {
  //           if(value) {
  //             thisRef.filtersData.filtered_values.role_id = value.toString();
  //           } else if(thisRef.filtersData.filtered_values.role_id) {
  //             delete thisRef.filtersData.filtered_values.role_id;
  //           }
  //           await thisRef.fetchSettingsStore(thisRef.filtersData.filtered_values);
  //         },
  //         async onScroll() {
  //         },
  //         async onFocus() {
  //         },
  //         async onSearch() {
  //         }
  //       },
  //   )
  //   this.filter_load = true
  // }

  validateForm(): void {
    this.resetValidationFields();
    this.isFormValid = false;
    if (!this.form.name) {
      this.validation.name.status = 'error';
      this.validation.name.help = i18nText("Пожалуйста, укажите ваше имя!");
    }
    if (!this.form.role_id) {
      this.validation.role.status = 'error';
      this.validation.role.help = i18nText("Пожалуйста, выберите роль для пользователя");
    }

    if (this.form.id !== this.userData.id && (!Array.isArray(this.form.studios) || !this.form.studios.length)) {
      this.validation.studios.status = 'error';
      this.validation.studios.help = i18nText("Пожалуйста, выберите студию для пользователя!");
    }
    if (!this.form.phone) {
      this.validation.phone.status = 'error';
      this.validation.phone.help = i18nText("Пожалуйста, укажите номер телефона!");
    }
    if (this.form.email && !this.form.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
      this.validation.email.status = 'error';
      this.validation.email.help = i18nText("Неверный формат email!");
    }
    if (this.userEditMode === 0) {
      if (!this.form.password.match(/\D/) || !this.form.password.match(/\d/) || !this.form.password.match(/[a-zA-Z0-9]{8,16}/)) {
        this.validation.password.status = 'error';
        this.validation.password.help = i18nText("Требования к паролю: длина 8-16 символов, использование латиницы, использование цифр!");
      }
    }

    let clearErrors = true;
    for (const property in this.validation) {
      if (this.validation[property].status === 'error') {
        clearErrors = false;
        break;
      }
    }

    if (clearErrors) {
      this.isFormValid = true;
    }
  }

  async onSubmit(): Promise<void> {
    (this.$refs.StoreForm as FormModel).validate(async (valid) => {
      if (valid) {
        try {
          this.isLoading = true;
          let response;

          this.form.studios = this.form.studios.map(Number);
          this.form.role_id = Number(this.form.role_id)
          this.validateForm();
          if (this.isFormValid) {
            if (this.userEditMode === 0) {
              response = await SettingsUsersStore.create(this.form)
            }
            else if (this.userEditMode === 1) {
              response = await SettingsUsersStore.update(this.form)
              if (this.form.id === this.userData.id && response.status) {
                const user = {...Vue.auth.user(), name: this.form.name, email: this.form.email, user_info: this.form.user_info};
                Vue.auth.user(user); sessionStorage.setItem('userData', JSON.stringify(user)); await AuthStore.fetchManual();
              }
            }
            await this.fetchSettingsStore()
          }

          if (response && !response.status) {
            throw new Error(response.response);
          }

          if (response) {
            this.$message.success(response.response);
            this.showModal = false;
          }

        } catch (e) {
          this.$message.info(e.message);
        } finally {
          this.isLoading = false;
        }
      }
    })
  }

  async SearchSalons(value: string): Promise<void> {
    await SalonsStore.fetchAll({ filter: { name: value } })
    this.assignDataSearch()
  }

  assignDataSearch(): void {
    if (SalonsStore.salons) {
      let items = [];
      items = SalonsStore.salons.data;
      this.dataSearch = [];
      items.forEach((item) => {
        this.dataSearch.push(item);
      });
    }
  }
  /*async getUsersData(filter = null): Promise<void> {
    if (filter !== null) {
      filter = {...filter, salon_id: this.currentlySelectedStudio};
    }
    else {
      filter = {salon_id: this.currentlySelectedStudio};
    }

    this.usersData = await (new UserRepository).fetchAll(prepareFormData({ filter: filter, limit: -1 }));
    this.$forceUpdate();
  }*/

  async fetchSettingsStore(filter = null): Promise<void> {
    if (filter !== null) {
      filter = { ...filter, salon_id: getStudioId(this) };
    }
    else {
      filter = { salon_id: getStudioId(this) };
    }

    await SettingsUsersStore.fetchAll({ limit: this.AppPageParams.pageSize, filter: filter });
  }
  async created(): Promise<void> {
    this.roles = await (new RolesRepository).fetchAll();

    this.resetValidationFields();
    this.tableLoad = false;
    if (!this.formReady) {
      try {
        // await this.createProxy();
        if (!SettingsUsersStore.ready) await this.fetchSettingsStore()
        if (!SalonsStore.ready) await SalonsStore.fetchAll({ limit: -1 });
        this.setFilters(this)
        this.assignDataSearch();
        /*await this.fetchModule([
          {s: 'salons',  p: {limit: -1}},
        ])*/
        this.proxyFilter = {
          salon_id: getStudioId(this)
        }
        appPaginationStore.setCurrent(1)
        await this.sortedData('desc', { dataIndex: 'created_at' })

      }
      catch (e) {
        console.log(e.message);
      }
      finally {
        await SalonsStore.setReady(true);
        //SettingsUsersStore.setReady(true);
        //await this.SearchSalons('')
        this.formReady = true;
        this.tableLoad = true;
      }

    }

  }

  async setFilter({ by, sort }: { by: string; sort: any }): Promise<void> {
    await this.sortedData(by, { dataIndex: sort.dataIndex })
  }

  async clearFilter(clear: string): void {
    await this.sortedData('desc', { dataIndex: 'created_at' })
  }

  async clearAFilter(): void {
    this.proxyFilter = {
      salon_id: getStudioId(this)
    }
    await this.sortedData('desc', { dataIndex: 'created_at' })
    for (let i of this.filterData) {
      if (i) {
        if (i.default_value) {
          i.default_value = [i18nText("Не указано")];
        } else {
          i.defaultValue = i18nText("Не указано");
        }
      }
    }
  }
}
